import { Card, Icon, PageLayout, Typography } from '@bharatpe/bharat-ui';
import AppHeader from 'components/atoms/AppHeader';
import React, { useEffect } from 'react';
import BankIcon from 'assets/icons/Autopay/bank.svg';
import PhoneIcon from 'assets/icons/Autopay/phone.svg';
import SimIcon from 'assets/icons/Autopay/sim.svg';
import './styles.scss';
import Lottie from 'lottie-react';
import ToggleCard from 'components/organisms/ToggleCard';
import { useSettlementAccount } from 'Slices/GetSettlementAccount';
import Failure from '../../../../assets/lottie/Failed.json';
import CrossIcon from 'assets/icons/Autopay/cross.svg';
import { closeNativeSupport } from 'utils/nativeSupport';
import { openDeepLinkWithCallback } from 'utils/nativeUpiHandler';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const style = {
	height: 84,
	witdh: 84,
};

const SimBindingFailure = () => {
	const settlementAccount = useSettlementAccount();
	const bankDetails = settlementAccount.data.data;
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page View',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'B_Not_Found',
			Module: 'Page',
			Action: 'View',
		});
	}, []);
	const handleBack = () => {
		logAnalyticsEvent({
			trigger_point: `Cross`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'BindingSuccess',
			Element: 'cross',
			Action: 'Tapped',
			source: 'appHeader',
		});
		closeNativeSupport();
	};

	const handleButtonClick = () => {
		// todo - update according to env
		logAnalyticsEvent({
			trigger_point: `Change Bank Account`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'B_Not_Found',
			Module: 'Change',
			Element: 'CTA',
			Action: 'Tapped',
			source: 'appHeader',
			ctaType: 'change',
		});
		openDeepLinkWithCallback('bharatpe://dynamic?key=add-bank-account', () => {
			console.log('close webview');
		});
	};
	const onChangeBankToggleClick = () => {
		logAnalyticsEvent({
			trigger_point: `Change Bank Account Number`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'B_Not_Found',
			Module: 'Change_B_AC_No',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'expand',
		});
	};

	const onSimToggleClick = () => {
		logAnalyticsEvent({
			trigger_point: `Change SIM on Device`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'B_Not_Found',
			Module: 'Change_S_O_D',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'expand',
		});
	};
	return (
		<PageLayout className="white-background">
			<>
				<div className="mt3">
					<AppHeader
						leftIconAction={handleBack}
						leftIcon={<Icon icon={CrossIcon} width={19} height={19} />}
						title={''}
					/>
				</div>
				<Card className="flex flex-column m4 p3">
					<Lottie animationData={Failure} loop={true} style={style} />
					<div className="content-center mb4">
						<Typography className="Bold600 danger">{languageData.ACCOUNT_IS_NOT_LINKED}</Typography>
					</div>

					<div className="flex flex-column content-center mb4">
						<Typography className="Regular100">{languageData.SELECTED_SIM_IS_NOT_LINKED_WITH_THE} </Typography>
						<Typography className="SemiBold200">
							{bankDetails?.name || ' '} XXXX XXXX {bankDetails?.account.slice(-4)}{' '}
						</Typography>
					</div>
					<div className="flex flex-column content-center mb4">
						<Typography className="Regular200 grey-dark">{languageData.ALL_SIM_CARDS_ON_YOUR_PHONE_ARE_NOT}</Typography>
						<Typography className="Regular200 grey-dark">{languageData.LINKED_WITH_YOUR_BANK_ACCOUNT}</Typography>
					</div>
				</Card>
				<div className="content-center mt9">
					<Typography className="Regular200 grey-dark">{languageData.PLEASE_TRY_WITH_BELOW_OPTIONS}</Typography>
				</div>
				<ToggleCard
					toggleFeature={false}
					primaryTitle={languageData.CHANGE_BANK_ACCOUNT}
					primaryDesc={languageData.WHICH_IS_LINKED_WITH_DEVICE_SIM}
					buttonName={languageData.CHANGE}
					buttonClick={handleButtonClick}
					icon={BankIcon}
					secondaryTitle={''}
				/>
				<ToggleCard
					toggleFeature={true}
					toggleAction={() => onChangeBankToggleClick()}
					primaryTitle={languageData.CHANGE_BANK_ACCOUNT}
					primaryDesc={languageData.WHICH_IS_LINKED_WITH_DEVICE_SIM}
					icon={PhoneIcon}
					secondaryTitle={languageData.STEPS_TO_UPDATE_PHONE_NUMBER}
					secondaryDesc={
						languageData.AN_EMI_CARD_IS_A_FINANCIAL_TOOL_ALLOWING_USERS_TO_MAKE_PURCHASES_AND_PAY_THEM_OFF_IN_FIXED_MONTHLY_INSTALLMENTS_OVER_A_SET_PERIOD_IT_OFFERS_A_LINE_OF_CREDIT_FOR_VARIOUS_ITEMS_DIVIDING_THE_TOTAL_COST_INTO_MANAGEABLE_PAYMENTS_WITH_ADDED_INTEREST
					}
				/>
				<ToggleCard
					toggleFeature={true}
					toggleAction={() => onSimToggleClick()}
					primaryTitle={languageData.CHANGE_SIM_ON_DEVICE}
					primaryDesc={languageData.WHICH_IS_LINKED_TO_YOUR_BANK_ACCOUNT}
					icon={SimIcon}
					secondaryTitle={languageData.STEPS_TO_UPDATE_PHONE_NUMBER}
					secondaryDesc={
						languageData.AN_EMI_CARD_IS_A_FINANCIAL_TOOL_ALLOWING_USERS_TO_MAKE_PURCHASES_AND_PAY_THEM_OFF_IN_FIXED_MONTHLY_INSTALLMENTS_OVER_A_SET_PERIOD_IT_OFFERS_A_LINE_OF_CREDIT_FOR_VARIOUS_ITEMS_DIVIDING_THE_TOTAL_COST_INTO_MANAGEABLE_PAYMENTS_WITH_ADDED_INTEREST
					}
				/>
			</>
		</PageLayout>
	);
};
export default SimBindingFailure;
